import { defineComponent as i, createVNode as c, renderSlot as a, h as m } from "vue";
import { useNamespace as d } from "../../hooks/use-namespace.js";
import "../../hooks/use-z-index.js";
import "./overlay.css";
const f = {
  mask: {
    type: Boolean,
    default: !0
  },
  customMaskEvent: {
    type: Boolean,
    default: !1
  },
  zIndex: {
    type: [String, Number]
  },
  overlayClass: {
    type: [String, Array, Object]
  }
}, u = {
  click: (e) => e instanceof MouseEvent
}, k = i({
  name: "ApOverlay",
  props: f,
  emits: u,
  setup(e, { slots: o, emit: s }) {
    const n = d("overlay"), l = (t) => {
      s("click", t);
    }, r = (t) => {
      e.customMaskEvent || l(t);
    };
    return () => e.mask ? c(
      "div",
      {
        class: [n.b(), e.overlayClass],
        style: {
          zIndex: e.zIndex
        },
        onClick: r
        // onMousedown,
        // onMouseup,
      },
      [a(o, "default")]
      // 2 | 4 | 8,
      // ['onClick', 'onMouseup', 'onMousedown']
    ) : m(
      "div",
      {
        class: e.overlayClass,
        style: {
          zIndex: e.zIndex,
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px"
        }
      },
      [a(o, "default")]
    );
  }
});
export {
  k as default,
  u as overlayEmits,
  f as overlayProps
};
